import { Directive, input } from '@angular/core';

export type TextSize = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type TextWeight = 'regular' | 'semibold' | 'bold' | 'black';
export type TextColor =
  | 'base'
  | 'tint1'
  | 'tint2'
  | 'white'
  | 'black'
  | 'blue-tint-1'
  | 'placeholder'
  | 'positive'
  | 'negative'
  | 'success'
  | 'error'
  | 'error-active'
  | 'warning'
  | 'accent'
  | 'secondary'
  | 'inline-link'
  | 'inline-link-active'
  | 'form-text-default'
  | 'form-text-active'
  | 'form-text-hover'
  | 'form-text-placeholder'
  | 'inherit';
export type TextLineHeight = '12' | '14' | '16' | '20' | '24' | '28' | '32' | '36' | '40' | '48' | '50' | '72';
export type TextLetterSpacing = '8-16' | '18-24' | '28-plus';

@Directive({
  selector: '[joii-text]',
  host: {
    '[attr.data-size]': 'size()',
    '[attr.data-weight]': 'weight()',
    '[attr.data-color]': 'color()',
    '[attr.data-line-height]': 'lineHeight()',
    '[attr.data-letter-spacing]': 'letterSpacing()',
  },
})
export class TextDirective {
  /**
   * The size of the text, ranging from 1 (smallest) to 12 (largest).
   * @default 5
   */
  readonly size = input<TextSize>(5);

  /**
   * The font weight of the text.
   * @default 'regular'
   */
  readonly weight = input<TextWeight>('regular');

  /**
   * The color variant of the text.
   * @default 'base'
   */
  readonly color = input<TextColor>('base');

  /**
   * Optional line height override. Uses theme line height variables (--Vetai-12, --Vetai-14, etc.).
   * When not provided, uses the default line height for the selected size.
   */
  readonly lineHeight = input<TextLineHeight>();

  /**
   * Optional letter spacing override. Uses theme letter spacing variables (--Vetai-8-16, --Vetai-18-24, --Vetai-28-plus).
   * When not provided, uses the default letter spacing for the selected size.
   */
  readonly letterSpacing = input<TextLetterSpacing>();
}
